<template>
    <div>
        <div v-if="getStartConsole > 0">{{prepareConsole()}}</div> 
        <small>{{vplProcessInfo}}</small>
        <div>          
            <v-btn-toggle v-model="tabIndex" mandatory>
                <v-btn x-small dense>Console</v-btn>
                <v-btn x-small dense>Compiler info</v-btn>
                <v-btn x-small dense>Exec-info</v-btn>
                <v-btn x-small dense>Test results</v-btn>
            </v-btn-toggle> 
            <div v-if="tabIndex == 0" class="d-flex flex-row">
                <v-textarea 
                    ref = "tta"
                    rows="8" 
                    v-model="terminal" 
                    background-color="#FFFFFF"
                    v-on:keydown="inputKeydown"
                ></v-textarea>

                <div class="d-flex flex-column py-2 ml-2">
                    <v-icon @click="killProcess()" color="red" title="Kill process" style="position: relative; top: 4px; right: 4px; z-index: 2;">stop</v-icon>     
                    <v-icon @click="clearConsole()" color="green" title="Clear console" style="position: relative; top: 4px; right: 4px; z-index: 2;">data_thresholding</v-icon>  
                </div>
            </div>
            <v-textarea v-if="tabIndex == 1"
                rows="5" 
                v-model="vplCompilerInfo" 
                readonly
                background-color="#EEEEEE"
            ></v-textarea>
            <v-textarea v-if="tabIndex == 2"
                rows="5" 
                v-model="vplExecutionInfo" 
                readonly
                background-color="#EEEEEE"
            ></v-textarea>
            <v-card v-if="tabIndex == 3" background-color="#CDCDCD">
                <v-card-text v-if="testResults.length>0">
                    <div v-for="(xtest, index) in testResults" :key="index">
                        <!-- <p v-if="xtest.test_result != 'OK'">  -->
                        <p v-if="xtest.test_result != '-OK'" @click="collapseClick(index)">
                            <v-icon color="green" v-if="xtest.test_result == 'OK'">check_circle_outline</v-icon>
                            <v-icon color="red" v-else>error</v-icon>
                            {{xtest.test_name}}
                            <v-icon color="red" v-if="xtest.test_result != 'OK'">keyboard_arrow_down</v-icon>
                            <v-icon color="green" v-else>keyboard_arrow_down</v-icon>
                        </p>
                        <v-card v-if="testResultsCollapse.includes(index)" >
                            <v-card-text>
                                <h3>Input:</h3>
                                <p v-html="'<pre>'+xtest.input+'</pre>'"></p>
                                <h3>Expected output:</h3>
                                <p v-html="'<pre>'+xtest.expected+'</pre>'"></p>
                                <h3>Your output:</h3>
                                <p v-html="'<pre>'+xtest.output+'</pre>'"></p>
                            </v-card-text>
                        </v-card>
                    </div>
                </v-card-text>
            </v-card>
        </div>
    </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import * as misc from '../../assets/misc.js'
  import configData from '../../config.js'
  import axios from '../../axios-auth.js'
   
    export default {
        data() {
            return {
                myExecutionSocket: null,
                terminal: '',
                terminalLocked: 0,
                monitoringSocket : null,
                myTickets : null,
                tabIndex : 0,
                vplCompilerInfo: '',
                vplExecutionInfo: '',
                vplProcessInfo: '',
                grade: 0,
                testResults: [],
                testResultsCollapse: []
            }
        },    
        computed: 
            mapGetters([
                'getStartConsole'              
            ]),
        destroyed() {
           this.closeSockets()  
        },
        props : {
            terminalIndex: {type: Number, default: 1},
            activity_type: {type: String},
            dcontent: {type: Object},
            taskIndex : {type: Number},
            startTime: {type: Date},
        },        
        methods: {      
            prepareConsole() {
                if (this.monitoringSocket != null) { // process is running
                    this.$store.commit('setStartConsole',0)
                    return 
                }
                if (this.getStartConsole != this.terminalIndex) return // first or second console
                this.$store.commit('setStartConsole',0)
                this.myTickets = this.$store.getters.getSocketTickets
                this.readVPLProcess(this.myTickets)
                this.tabIndex = 0
                this.vplCompilerInfo = ''
                this.vplExecutionInfo = ''
                this.testResults = []
                this.grade = 0
            },
            readVPLProcess(tickets) {
                let monitoringTarget = configData.jailSocketConnection + tickets.monitorticket+'/monitor'
                let executionTarget = configData.jailRunSocketConnection + tickets.executionticket+'/execute'

                this.ProcessInfo('awaiting connection... ')

                this.monitoringSocket = new WebSocket(monitoringTarget)
                  this.monitoringSocket.onopen = () => { this.ProcessInfo("connected... ") }
                  this.monitoringSocket.onmessage = ({data}) => {
                      if (data.substring(data.length - 3) == 'seg') data = data.substring(0, data.length - 2) + '.'
                      this.ProcessInfo(data)
                      if (data == 'run:terminal') {
                          this.processExecutionSocket(executionTarget)
                      }
                      if (data == 'retrieve:') { // compilation successfull, start running
                            this.getResult()
                        }
                        if (data == 'close:') { 
                            this.closeSockets()
                        }
                        if (data.substring(0,12) == 'compilation:') { // error in compilation
                            if (data.substring(12).length > 0) {
                                this.addToTerminal(data.substring(12))
                            }
                        }
                    }
                  this.monitoringSocket.onerror = ({data}) => { this.$store.commit('setFeedback', data)  }                
            },
            processExecutionSocket(_executionSocket) {  
                // set cursor
                this.$refs.tta.focus()         
                const textarea = this.$refs.tta.$refs.input       
                // textarea.scrollTop = textarea.scrollHeight          
                this.$nextTick().then(() => { 
                    textarea.selectionStart = this.terminalLocked; textarea.selectionEnd = this.terminalLocked
                })
                

                // open execution socket
                this.myExecutionSocket = new WebSocket(_executionSocket)
                this.terminalLocked = this.terminal.length
                    this.myExecutionSocket.onopen = () => { this.ProcessInfo("execution connected... ") }
                    this.myExecutionSocket.onerror = ({xdata}) => { 
                        this.processInfo("error execution..." + xdata)
                        this.getResult()
                    }
                    this.myExecutionSocket.onmessage = ({data}) => { this.writeServerData(data) }
                    this.myExecutionSocket.onclose = () => {};                    
            },
            writeServerData(_socketData) {              
              this.terminal += misc.hardReplace(_socketData,'\r','')
              this.terminalLocked = this.terminal.length
              if (this.dcontent.task_type_id && _socketData == "sqlite> ") this.killProcess(true) // stop sqlite on server
            },
            sendData() {
              const x = this.terminal.substring(this.terminalLocked) + '\n' 
              this.terminal = this.terminal.substring(0, this.terminalLocked)
              this.myExecutionSocket.send(x)
            },
            killProcess(_silent) {
                if (this.monitoringSocket == null) return
                let data = {
                    adminticket: this.myTickets.adminticket
                }
                axios.post('/vpl-stop', data, this.$store.getters.getAxiosConfig )
                .then(() => {
                    if (!_silent) this.addToTerminal('\n----- interrupted by user -----\n')
                    this.finishProcess()
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                    this.finishProcess()
                })
            },
            addToTerminal(_data) {
                this.terminal += _data
                this.terminalLocked = this.terminal.length
            },
            clearConsole() {
                this.terminal = ''
                this.terminalLocked = 0
            },
            getResult() {
                let d = { 
                    adminticket: this.myTickets.adminticket, 
                    task_type_id: this.dcontent.task_type_id,
                    tests_description: true, // return list of tests    
                    task_id: this.dcontent.task_id,
                    activity_type: this.activity_type,
                    time_length: Math.floor((new Date() - this.startTime)/1000 + 0.5)
                }
                this.ProcessInfo('reading result')
                axios.post('/vpl-get-result33', d, this.$store.getters.getAxiosConfig )
                    .then((res) => {
                        this.vplCompilerInfo = res.data.compilation
                        this.vplExecutionInfo = res.data.execution
                        this.ProcessInfo('')
                        if (this.vplExecutionInfo != null && this.vplExecutionInfo.length > 1) {
                            this.tabIndex = 2
                            let pos = res.data.execution.indexOf('Grade :=>>')
                            if (pos>-1) {
                                this.grade = parseInt(res.data.execution.substring(pos+10).trim())
                                this.finishProcess()
                            }
                            this.prepareUserTestsView(res.data.execution)
                            this.prepareResults()
                        }
                        if (this.vplCompilerInfo != null && this.vplCompilerInfo.length > 1) {
                            this.tabIndex = 1
                            this.prepareResults()
                        }
                    })
                    .catch(error => {
                        this.$store.commit('setFeedback', error)
                        this.finishProcess()
                    })
            },
            prepareResults() {
                this.$store.commit('setTransferAnswer',{index: this.taskIndex, rating: this.grade})
                this.$store.commit('setWaitingForResult',false) // data was delivered
                this.$store.commit('setCheckRatingEvent',true)
            },
            prepareUserTestsView(_data) {
                if (this.dcontent.task_type_id == 8) this.ProcessTestResults8(_data)
                if (this.dcontent.task_type_id == 9) {
                    if (this.$store.getters.getEditorType == 'text/x-java') // and java
                        this.ProcessTestResults9(_data)
                        // python!!!!
                    }    
                this.tabIndex = 3        
            },    
            ProcessInfo(_data){
                this.vplProcessInfo = _data
                this.$store.commit('setVplProcessInfo', _data)
            },
            closeSockets() {
                this.ProcessInfo('')
                if (this.monitoringSocket) {
                    this.monitoringSocket.close()
                    this.monitoringSocket = null
                }
                if (this.myExecutionSocket) {
                    this.myExecutionSocket.close()
                    this.myExecutionSocket = null
                }
                this.addToTerminal('----- done ----- \n')
                this.finishProcess()
            },
            finishProcess() {
                const _data = {
                    terminalIndex : this.terminalIndex,
                    grade: this.grade
                }
                this.ProcessInfo('')
                this.$store.commit('setConsoleGrade',_data)
                this.$store.commit('setWaitingForResult',false) 
            },
            inputKeydown(e) {
                if (e.keyCode == 13) {e.preventDefault(); this.sendData()}
                if (e.keyCode == 39 || e.keyCode == 37) return
                if (e.keyCode < 47 && e.keyCode != 8 && e.keyCode != 32) {
                    e.preventDefault()
                    return
                }
                const textarea = this.$refs.tta.$refs.input
                let pos = textarea.selectionStart
                if (pos < this.terminalLocked) {
                    e.preventDefault()
                    return
                }
                if (e.keyCode == 8) {
                    e.preventDefault()
                    if (pos == this.terminalLocked) return
                    this.terminal = this.terminal.substring(0, pos-1) + this.terminal.substring(pos)                    
                    this.$nextTick().then(() => { textarea.selectionStart = pos-1; textarea.selectionEnd = pos-1})
                    return
                }
            },
        collapseClick(index) {
            const i = this.testResultsCollapse.indexOf(index)
            if ( i > -1) {
                this.testResultsCollapse.splice(i,1)
            } else {
                this.testResultsCollapse.push(index)
            }
        },
        ProcessTestResults9(data) {
            // console.log(data)
            this.testResults = [] 
            var no = 1
            var index = 0
            while (data.indexOf("!--- Test", index) > -1) {
                const name_start = data.indexOf("!--- Test", index)
                const name_end = data.indexOf("\n", name_start)
                no = 1
                while (data.indexOf("!--- result", index) > -1) {
                    const result_start = data.indexOf("!--- result", index)
                    const result_end = data.indexOf("\n", result_start)
                    const input_starttmp = data.indexOf("!--- input values", result_end)
                    const input_start = data.indexOf("\n", input_starttmp) + 1
                    const input_end = data.indexOf("!--- program output", input_start + 1)
                    const output_starttmp = data.indexOf("!--- program output", input_end)
                    const output_start = data.indexOf("\n", output_starttmp) + 1
                    const output_end = data.indexOf("!--- expected output", output_start)
                    const expected_starttmp = data.indexOf("!--- expected output", output_end)
                    const expected_start = data.indexOf("\n", expected_starttmp) + 1
                    var expected_end = data.indexOf("!---", expected_start)
                    if (expected_end == -1) expected_end = data.indexOf("Grade", expected_start)
                    this.testResults.push( {
                        test_name: "(" + no + ") " + data.substring(name_start + 10, name_end),
                        test_result: data.substring(result_start + 13, result_end),
                        input: data.substring(input_start, input_end),
                        output: data.substring(output_start, output_end),
                        expected: data.substring(expected_start, expected_end)
                    })
                    // console.log(this.testResults[this.testResults.length - 1])
                    index = expected_end
                    no++
                    // next result is after test?
                    if ((data.indexOf("!--- Test", index)>-1) && (data.indexOf("!--- Test", index)<data.indexOf("!--- result", index)))
                     break;
                }
            } 
        },
        ProcessTestResults8(data) {
            this.testResults = []
            var xd = data.substring(0,data.indexOf("<|--"))
            while (xd.indexOf(': ')>-1) {
                this.testResults.push( {
                    test_name: xd.substring(xd.indexOf(': ')+2, xd.indexOf('\n')),
                    test_result: '-OK',
                    input: '',
                    output: '',
                    expected: ''
                })
                xd = xd.substring(xd.indexOf('\n')+1)
            } 
//            var onebad = -1

            if (data.indexOf('<|--\n-Failed tests')>-1) {
                const ft = data.indexOf('<|--\n-Failed tests')
                const eft = data.indexOf('--|>', ft)
                xd = data.substring(ft, eft)
                const edt = data.indexOf('--|>', eft+1)
                var xxd = data.substring(eft+4, edt+4)
                for(let i = 0; i < this.testResults.length; i++) {
                    const name = 'Test '+(i+1)+': '+ this.testResults[i].test_name
                    if (xd.indexOf(name) > -1 ) {
                        // we have bad test
                        this.testResults[i].test_result = 'failed'
                        // find --- Input
                        var n1pos = xxd.indexOf('\n',xxd.indexOf('--- Input',xxd.indexOf('-' + name)))
                        // n1pos = xxd.indexOf('\n',n1pos+1)
                        var n2pos = xxd.indexOf('\n --- Program output',n1pos+1)
                        // 
                        this.testResults[i].input = this.delChars(xxd.substring(n1pos+1,n2pos),'>','\n')
                        // find --- Program output                        
                        n2pos = xxd.indexOf('\n',n2pos+1)
                        n1pos = xxd.indexOf('\n --- Expected output',n2pos+1)
                        // 
                        this.testResults[i].output = this.delChars(xxd.substring(n2pos+1,n1pos),'>','\n')
                        // find --- Expected output
                        n1pos = xxd.indexOf('\n',n1pos+1)
                        n2pos = xxd.indexOf('\n-Test ',n1pos)
                        if (n2pos < 0) n2pos = xxd.indexOf('\n--|>',n1pos)                        
                        this.testResults[i].expected = this.delChars(xxd.substring(n1pos+1,n2pos),'>','\n')
                    }
                }
            } else {
                if (data.indexOf('\nIncorrect program output') > -1) {
                    // console.log(data)    
                    var n1p = data.indexOf('<|--\n-Test ')
                    var n2p = data.indexOf(':',n1p)
                    let x_index = data.substring(n1p+11,n2p) - 1
                    this.testResults[x_index].test_result = 'failed'

                    // find --- Input
                    n1p = data.indexOf('\n',data.indexOf('--- Input'))
                    n2p = data.indexOf('\n --- Program output',n1p+1)
                    // 
                    this.testResults[x_index].input = this.delChars(data.substring(n1p+1,n2p),'>','\n')
                    // find --- Program output                        
                    n2p = data.indexOf('\n',n2p+1)
                    n1p = data.indexOf('\n --- Expected output',n2p+1)
                    // 
                    this.testResults[x_index].output = this.delChars(data.substring(n2p+1,n1p),'>','\n')
                    // find --- Expected output
                    n1p = data.indexOf('\n',n1p+1)
                    n2p = data.indexOf('\n-Test ',n1p)
                    if (n2p < 0) n2p = data.indexOf('\n--|>',n1p)                        
                    this.testResults[x_index].expected = this.delChars(data.substring(n1p+1,n2p),'>','\n')
                }
            }                       
        },
        delChars(data,f,l){
            var i = 0
            while (data.indexOf('\n>')>-1) {
                i = data.indexOf('\n>')
                data = data.substring(0,i+1) + data.substring(i+2)
            }
            data = data.substring(data.length-1) == l ? data.substring(0,data.length-1) : data
            return (data.substring(0,1) == f) ? data.substring(1) : data
        },

        }
    }
    </script>

